import UserRolePage from './UserRolePage.jsx';
export default function InactiveUsersPage() {
  return <UserRolePage title="Inactive Users" accentColor="#94a3b8"
    initialFilters={{ status:'Inactive' }} />;
}